export const ANALYTICS_APP_TYPE_FOR_SENTRY: Record<string, string> = {
  PGDB: 'PG',
  PG: 'PG',
  CDB: 'PG',
  OB: 'OB',
};
